import Vue from 'vue';

import { registerComponents, Components } from '@cnamts/vue-dot/src/helpers/registerComponents';

import AppPage from './AppPage';

export const components: Components = {
	AppPage
};

registerComponents(Vue, components);
